import { render, staticRenderFns } from "./AttentionCompanyAll.vue?vue&type=template&id=06c0a566&scoped=true"
import script from "./AttentionCompanyAll.vue?vue&type=script&lang=js"
export * from "./AttentionCompanyAll.vue?vue&type=script&lang=js"
import style0 from "./AttentionCompanyAll.vue?vue&type=style&index=0&id=06c0a566&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0a566",
  null
  
)

export default component.exports